import React, { Fragment } from 'react';
import { APIHOST, HRHOST } from '../../config';
import { layout } from 'styled-system';
import Form from 'antd/lib/form';
import AntdFormItem from 'antd/lib/form/FormItem';
import AntInput from 'antd/lib/input';
import notification from 'antd/lib/notification';
import Axios from 'axios';
import styled from 'styled-components';
import { nanoid } from 'nanoid';
import { Flex, Box } from '../../components/Flex';
import { Text } from '../../components/Text';
import promoteIcon from '../../images/people@2x.png';
import keysIcon from '../../images/keys.svg';
import { GradientButton } from '../../components/buttons';
import PhoneInput from '../../components/PhoneInput';
import Banner from './Banner';

const Input = styled(AntInput)`
  ${layout}
`;
const FormItem = styled(AntdFormItem)`
  margin-bottom: 8px;
  & .ant-form-item-label label {
    color: #666;
    font-weight: 600;
  }

  & .ant-form-item-required:before {
    // remove the red '*' required symbol
    display: none;
  }

  & .ant-form-item-label label:after {
    // remove the ':' after the field label
    display: none;
  }
`;

class Signup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      phoneNumber: '',
      regionNumber: '',
      phoneNumberValidateStatus: true,
      confirmPwdError: undefined,
      isSubmitting: false,
      currentStep: 1, // 1: email, 2: passwrod

      // data
      email: '',
      guestId: nanoid(),
    };
  }

  componentDidMount() {
    this.logSignupEvent({ step: 1 });
  }

  logSignupEvent({ step, email }) {
    const data = {
      page_url: window.location.href,
      guest_id: this.state.guestId,
      anonymous_id: this.state.guestId,
      step_number: step,
      ...(email && { email }),
      is_final_step: false,
    };
    const config = {
      method: 'post',
      url: `${APIHOST}/v2/segment_tracks/visit_self_serve_sign_up`,
      data,
    };
    Axios(config);
  }

  handleClickSignup() {
    const { form } = this.props;
    form.validateFields((err, values) => {
      if (err) {
        return;
      }

      // add step=account to URL
      const { search } = window.location;
      let searchString;
      if ( !search ) {
        searchString = `?step=account`;
      } else if (search.indexOf('step=account') === -1){
        searchString = `${search}&step=account`;
      } else {
        searchString = search;
      }
      changeQueryString(searchString);
      this.logSignupEvent({ step: 2, email: values.email })
      this.setState({ currentStep: 2, ...values });
    });
  }

  handleSubmit() {
    const { form } = this.props;
    form.validateFields((err, values) => {
      let phoneNumberError;
      let confirmPwdError;
      // check phone number
      const { phoneNumberValidateStatus, phoneNumber, regionNumber } = this.state;
      if (phoneNumberValidateStatus === false || !phoneNumber) {
        phoneNumberError = true;
        this.setState({
          phoneNumberErrorMsg: 'Please enter a correct phone number',
          phoneNumberValidateStatus: false,
        });
      }
      // check confirm password match
      const { confirm_password, password } = values;
      if (confirm_password !== password) {
        confirmPwdError = 'Please confirm the correct password!';
        this.setState({ confirmPwdError });
      }
      if (err || confirmPwdError || phoneNumberError) {
        return;
      }

      const fullName = `${values.first_name} ${values.last_name}`;
      delete values.first_name;
      delete values.last_name;
      const config = {
        method: 'post',
        url: `${APIHOST}/v1/sessions/sign_up`,
        data: {
          ...values,
          name: fullName,
          email: this.state.email,
          region_number: `+${regionNumber}`,
          phone: phoneNumber,
        },
      };
      this.setState({ isSubmitting: true });
      Axios(config)
        .then((response) => {
          this.setState({ isSubmitting: false });
          const {
            auth_token,
            user: { id: userId },
          } = response.data;
          notification.success({
            message: 'Signup success',
            description: 'We will redirect you to the main site.',
          });
          // Segment.com track
          const { password: pwd, confirm_password: cfm_pwd, ...trackData } = config.data;
          // eslint-disable-next-line
          analytics.identify(userId, trackData, () => {
            // eslint-disable-next-line
            analytics.track('Self Serve Signup', trackData, () => {
              window.location.href = `${HRHOST}/lite.html#/positions?ws_token=${auth_token}`;
            });
          });
        })
        .catch((err) => {
          this.setState({ isSubmitting: false });
          let errorMessage = 'Please contact help@workstream.is for details.';
          if (err.response && err.response.data && err.response.data.message) {
            errorMessage = err.response.data.message;
          }
          notification.error({
            message: 'Something went wrong',
            description: errorMessage,
          });
        });
    });
  }

  updatePhoneNumber(status, value, countryData) {
    const regionNumber = countryData.dialCode;
    let phoneNumber = value;

    if (phoneNumber.indexOf('+') !== -1) {
      phoneNumber = phoneNumber.replace(`+${regionNumber}`, '');
    }

    this.setState({
      phoneNumber,
      regionNumber,
      phoneNumberValidateStatus: status,
      phoneNumberErrorMsg: '',
    });
  }

  render() {
    const { currentStep } = this.state;
    const { getFieldDecorator } = this.props.form;

    return (
      <Flex flexDirection="column" alignItems="center">
        <Banner />
        <Flex
          mt={[0, 87]}
          height={['auto']}
          boxShadow={['none', '0px 2px 14px rgba(13, 140, 230, 0.0962692)']}
          borderRadius={[0, '5px']}
          bg="white"
          justifyContent="center"
          width={['100%', 'auto']}
          maxWidth={747}
          px={['0', '66px']}
        >
          {/* Workstream Setup */}
          {currentStep === 1 && (
            <Box pt={82} mr={84} display={['none', 'block']}>
              <img src={promoteIcon} alt="workstream-illustration" width="245" />
            </Box>
          )}
          {currentStep === 2 && (
            <Box pt={117} pl={28} mr={108} display={['none', 'block']}>
              <img src={keysIcon} alt="workstream logo" width={193} />
            </Box>
          )}

          {/* Form part */}
          <Flex column pt={[34, 52]} pb={55} style={{}}>
            <Flex flexDirection="column" width="280px">
              {this.state.currentStep === 1 && (
                <Fragment>
                  <Box mt={26}>
                    {/* title */}
                    <Flex justifyContent={['center', 'flex-start']} column>
                      <Text fontSize="24px" color="#000">
                        Welcome to Workstream.
                      </Text>
                      <Text color="#969696" fontSize="20px" textAlign={['center', 'left']}>
                        We help hiring managers get people in the door fast!
                      </Text>
                    </Flex>
                    <Box mt={56} display={['block', 'none']}>
                      <img src={promoteIcon} alt="workstream-mobile" width="245" />
                    </Box>
                  </Box>
                  <Flex column mt={28}>
                    <FormItem label="Work email">
                      {getFieldDecorator('email', {
                        rules: [
                          { required: true, message: 'Please input your email!' },
                          { type: 'email', message: 'The input is not valid email!' },
                        ],
                      })(<Input size="large" onPressEnter={this.handleClickSignup.bind(this)} />)}
                    </FormItem>
                  </Flex>
                  <Box mt={28} />
                  <GradientButton rightArrow onClick={this.handleClickSignup.bind(this)}>
                    Sign up
                  </GradientButton>
                  <Flex mt={30}>
                    <Text>
                      Do you have an account? <a href={`${HRHOST}/lite.html#/login`}> Log in</a>
                    </Text>
                  </Flex>
                </Fragment>
              )}
              {this.state.currentStep === 2 && (
                <Fragment>
                  <Box mt={26} mb={33}>
                    <Flex justifyContent={['center', 'flex-start']} column>
                      <Box display={['block', 'none']} textAlign="center">
                        <img src={keysIcon} alt="setup password" width="193" />
                      </Box>
                      <Text
                        fontSize="24px"
                        color="#000"
                        textAlign={['center', 'left']}
                        mt={['45px', 0]}
                      >
                        Create your account.
                      </Text>
                    </Flex>
                  </Box>
                  <Flex>
                    <FormItem label="First name">
                      {getFieldDecorator('first_name', {
                        rules: [{ required: true, message: 'Please input your first name!' }],
                      })(<Input size="large" />)}
                    </FormItem>
                    <Box ml={13} />
                    <FormItem label="Last name">
                      {getFieldDecorator('last_name', {
                        rules: [{ required: true, message: 'Please input your last name!' }],
                      })(<Input size="large" />)}
                    </FormItem>
                  </Flex>
                  <FormItem label="Company name">
                    {getFieldDecorator('company_name', {
                      rules: [{ required: true, message: 'Please input your company name!' }],
                    })(<Input size="large" />)}
                  </FormItem>
                  <FormItem
                    label="Phone number"
                    help={this.state.phoneNumberErrorMsg || ''}
                    validateStatus={this.state.phoneNumberValidateStatus === false ? 'error' : ''}
                  >
                    <PhoneInput
                      style={{ width: '100%' }}
                      defaultValue={this.state.regionNumber + this.state.phoneNumber}
                      onPhoneNumberChange={this.updatePhoneNumber.bind(this)}
                      preferredCountries={['us', 'sg', 'ca']}
                      inputClassName="ant-input ant-input-lg"
                    ></PhoneInput>
                  </FormItem>
                  <FormItem label="Create your password">
                    {getFieldDecorator('password', {
                      rules: [
                        { required: true, message: 'Please input your password!' },
                        { min: 6, message: 'Password should at least contains 6 characters.' },
                      ],
                    })(<Input type="password" size="large" />)}
                  </FormItem>
                  <FormItem
                    label="Confirm password"
                    {...(this.state.confirmPwdError && { validateStatus: 'error' })}
                    help={this.state.confirmPwdError}
                  >
                    {getFieldDecorator('confirm_password', {
                      rules: [
                        { required: true, message: 'Please comfirm your password!' },
                        { min: 6, message: 'Password should at least contains 6 characters.' },
                      ],
                    })(
                      <Input
                        size="large"
                        type="password"
                        onChange={() => {
                          this.setState({ confirmPwdError: undefined });
                        }}
                        onPressEnter={this.handleSubmit.bind(this)}
                      />
                    )}
                  </FormItem>

                  <Box mt={28} />
                  <GradientButton
                    onClick={this.handleSubmit.bind(this)}
                    loading={this.state.isSubmitting}
                  >
                    Start hiring
                  </GradientButton>
                </Fragment>
              )}
            </Flex>
          </Flex>
        </Flex>
      </Flex>
    );
  }
}

export const changeQueryString = (searchString, documentTitle, noTrack) => {
  documentTitle = typeof documentTitle !== 'undefined' ? documentTitle : document.title;
  const urlSplit = window.location.href.split('?');
  const obj = { Title: documentTitle, Url: urlSplit[0] + searchString };
  window.history.pushState(obj, obj.Title, obj.Url);
  if (window.analytics && !noTrack) {
    // track URL change using segment
    window.analytics.page({ url: window.location.href });
  }
}

export default Form.create()(Signup);
